import styledComponents from 'styled-components'

export const ChatWrapper = styledComponents.div`
  width: 100%;
  max-width: 800px;
  border: 1px solid #cbcbcb;
  border-radius: 5px;
  overflow: hidden;
`

export const ChatBody = styledComponents.div<{ state?: 'loading' | 'empty' | 'normal' }>`
  overflow-y: auto;
  outline: none;
  padding: 10px;
  height: 300px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: ${props =>
    props.state === 'loading' || props.state === 'empty' ? 'center' : 'flex-start'};
  align-items: ${props =>
    props.state === 'loading' || props.state === 'empty' ? 'center' : 'stretch'};
  gap: 8px;

  /* Анимация цвета текста при loading */
  color: ${props =>
    props.state === 'loading' ? '#1890ff' : props.state === 'empty' ? '#777777' : '#000'};
  animation: ${props =>
    props.state === 'loading' ? 'colorChange 2s infinite ease-in-out' : 'none'};

  @keyframes colorChange {
    0% {
      color: #1890ff;
    }
    50% {
      color: #777777;
    }
    100% {
      color: #1890ff;
    }
  }
`

export const MessageRow = styledComponents.div<{ $left?: boolean }>`
  display: flex;
  justify-content: flex-end;
  flex-direction: ${props => (props.$left ? 'row-reverse' : 'row')};
`

export const MessageText = styledComponents.div<{ $incoming: boolean; $is_read?: boolean }>`
  padding: 4px 10px;
  border: 1px solid #ccc;
  border-radius: ${props => (props.$incoming ? '0 6px 6px 6px' : '6px 0 6px 6px')};
  font-size: 16px;
  background: ${props => (props.$incoming ? '#96f2fa' : '#e0f69f')};
  white-space: pre-wrap;
  box-shadow: ${props => (props.$is_read ? 'none' : '0 0 5px 1px #58c858')};
  transition: box-shadow 0.2s ease;
  max-width: min(100%, 560px);
`

export const MessageDate = styledComponents.div<{ $incoming?: boolean }>`
  text-align: right;
  font-size: 12px;
  margin-top: 4px;
  color: #5a5a5a;
`

export const ChatFooter = styledComponents.div`
  padding: 10px;
  position: relative;
  background-color: #eceff1;
  border-top: 1px solid #ccc;
`

export const ButtonActionWrapper = styledComponents.button`
  margin: 0;
  font-size: 20px;
  border: none;
  background: none;
  cursor: pointer;
  padding: 6px;
`

export const LoadingPreloader = styledComponents.div`
  margin: 0;
  font-size: 20px;
  border: none;
  background: none;
  cursor: pointer;
  padding: 6px;
`

export const MessageAttachments = styledComponents.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
`

export const MessageAttachmentLink = styledComponents.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  padding: 8px 10px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.55);
  color: #1f1f1f;
  text-decoration: none;
  word-break: break-word;
`

export const MessageAttachmentImage = styledComponents.img`
  display: block;
  max-width: 180px;
  max-height: 140px;
  border-radius: 10px;
  object-fit: cover;
  background: #fff;
`

export const FooterActions = styledComponents.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`

export const FooterLeftActions = styledComponents.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const AttachInput = styledComponents.input`
  display: none !important;
  width: 0;
  height: 0;
  opacity: 0;
  position: absolute;
  pointer-events: none;
`

export const AttachButton = styledComponents.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid #c8c8c8;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
`

export const SelectedFiles = styledComponents.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
`

export const SelectedFileItem = styledComponents.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 10px;
  border: 1px solid #d8d8d8;
  border-radius: 10px;
  background: #fff;
`

export const SelectedFileInfo = styledComponents.div`
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #1f1f1f;
`

export const SelectedFileName = styledComponents.div`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const SelectedFileSize = styledComponents.span`
  flex-shrink: 0;
  color: #7a7a7a;
  font-size: 12px;
`

export const SelectedFileRemove = styledComponents.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #8a8a8a;
  cursor: pointer;
`
